import { Breadcrumbs } from '@sravni/react-seo';
import getConfig from 'next/config';
import type { FC } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { metadataSelector } from 'entities/metadata';

export const SeoBreadcrumbs: FC = () => {
  const metadata = useAppSelector(metadataSelector);
  const { publicRuntimeConfig } = getConfig();
  const { isMarketplace } = publicRuntimeConfig || {};

  if (!metadata?.breadcrumbs?.length) {
    return null;
  }

  return (
    <Breadcrumbs
      data-qa="Breadcrumb"
      items={metadata.breadcrumbs}
      needMainPage={!isMarketplace}
    />
  );
};
